import { useMutation } from 'react-query';
import axios from 'axios';

import { backendRequestHeaders, getBackendBaseUrl, resolveBearerToken } from '@/api/backendAuth';
import { useAppSelector } from '@/app/hooks';
import { SegmentRule } from '@/models/Segments';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';

export type PrecalculateSegmentResponse = { data: unknown[] };

async function precalculateSegment(data: SegmentRule, sessionJwt: string | undefined, workspaceId: string) {
  const bearer = resolveBearerToken(sessionJwt);
  const headers = backendRequestHeaders(bearer || undefined);
  if (!headers.Authorization) {
    throw new Error('Missing Bearer token. Please sign in again.');
  }

  const response = await axios.post<PrecalculateSegmentResponse>(
    `${getBackendBaseUrl()}/workspaces/${workspaceId}/audience/precalculate`,
    data,
    { headers },
  );
  return response.data;
}

export function usePrecalculateSegment() {
  const { user } = useAuth();
  const workspace = useAppSelector(selectCurrentWorkspace);
  return useMutation<PrecalculateSegmentResponse, Error, SegmentRule>((data) =>
    precalculateSegment(data, user?.signInUserSession?.idToken?.jwtToken, workspace?.id ?? ''),
  );
}
